"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nCore = void 0;
/* eslint-disable padding-line-between-statements */
var I18nCore_1 = require("./I18nCore");
Object.defineProperty(exports, "I18nCore", { enumerable: true, get: function () { return I18nCore_1.I18nCore; } });
// eslint-disable-next-line local-rules/no-export-*
__exportStar(require("./I18nCore/types"), exports);
//# sourceMappingURL=index.js.map